import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { MainLayout } from '@/components/layout/MainLayout';
import { PaymentTransactionLifecycleEventsContent } from './PaymentTransactionLifecycleEventsContent';

export default function PaymentTransactionLifecycleEventsPage() {
    return (
        <ProtectedRoute>
            <MainLayout>
                <PaymentTransactionLifecycleEventsContent />
            </MainLayout>
        </ProtectedRoute>
    );
}
